export const ActivityRequiringAttentionType = Object.freeze({
  stalledWithClient: 0,
  actionRequired: 1,
  lenderUpdates: 2,
});

export const ActivityRequiringAttentionTypeLabel = Object.freeze({
  [ActivityRequiringAttentionType.stalledWithClient]: 'Stalled with Client',
  [ActivityRequiringAttentionType.actionRequired]: 'Action Required',
  [ActivityRequiringAttentionType.lenderUpdates]: 'Lender Updates',
});

export const ActivityRequiringAttentionTypeOptions = Object.values(
  ActivityRequiringAttentionType,
).map((value) => ({ label: ActivityRequiringAttentionTypeLabel[value], value }));
